import BUserPicker from '@/views/app/BUserPicker.vue'

export default {
  data () {
    return {
      // NOTE:Vue调试工具的bug，在组件属性中看到的$$pickedUsers始终为<empty object>
      $$pickedUsers: { }
    }
  },
  __pickUsersMixin: {
    dialogs: new Set()
  },
  beforeRouteLeave (to, from, next) {
    const dialogs = this.$options.__pickUsersMixin.dialogs
    if (dialogs.size) {
      for (const dialog of dialogs) {
        dialog.hide()
      }
      dialogs.clear()
    } else {
      next()
    }
  },
  methods: {
    $$pickUsers ({
      key,
      title,
      users,
      onOk,
      onCancel,
      onDismiss,
      discardPickedUsers,
      whiteList
    }) {
      return new Promise((resolve, reject) => {
        const dialog = this.$q.dialog({
          parent: this,
          component: BUserPicker,
          // props forwarded to component
          // (everything except "component" and "parent" props above):
          title: title,
          users: users,
          profileKey: key,
          whiteList: whiteList
        })
        this.$options.__pickUsersMixin.dialogs.add(dialog)
        dialog.onOk(args => {
          if (!discardPickedUsers) {
            this.$$pickedUsers = args.pickedUsers ?? { }
          }
          try {
            onOk && onOk.call(this, args)
          } catch (error) {
            console.error('pick users onOk', error)
          }
          resolve.call(this, args)
        }).onCancel(() => {
          const args = { success: false }
          try {
            onCancel && onCancel.call(this, args)
          } catch (error) {
            console.error('pick users onCancel', error)
          }
          resolve.call(this, args)
        }).onDismiss(args => {
          this.$options.__pickUsersMixin.dialogs.delete(dialog)
          onDismiss && onDismiss.apply(this, arguments)
        })
      })
    }
  }
}
